import React from "react";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import moment from "moment";
import { Button } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const InfoRow = ({ label, value }) => (
  <Grid item xs={12} sm={6}>
    <Box sx={{ textAlign: "center" }}>
      <Typography variant="p">
        <strong>{label} </strong> <br />
        {value || "N/A"}
      </Typography>
    </Box>
  </Grid>
);

const CalibrationStartEndTimeModal = ({ open, handleClose, datasheetDetails, allUsers }) => {
  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 600,
          "@media (max-width: 600px)": { width: "80%" },
          "@media (max-width: 480px)": { width: "90%" },
          bgcolor: "background.paper",
          border: "1px solid #000",
          boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
          p: 2,
        }}
      >
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <Typography variant="h5" align="center" sx={{ color: "#001E6C", flexGrow: 1 }}>
            <b>Calibration Activity</b>
          </Typography>
          <Button variant="contained" size="small" onClick={handleClose} sx={{ minWidth: "0px" }}>
            <CloseIcon />
          </Button>
        </Box>

        <br />
        <Grid container spacing={2}>
          <InfoRow label="Instrument Name" value={datasheetDetails?.requestedname || datasheetDetails?.instrumentName} />
          <InfoRow label="DUCID" value={datasheetDetails?.DUCID} />
          <InfoRow
            label="Serial Number"
            value={datasheetDetails?.serialNumber
              ? datasheetDetails?.serialNumber
              : "N/A"}
          />
          <InfoRow
            label="Calibrated By"
            value={allUsers?.find((user) => user.id == datasheetDetails?.calibratedBy)?.userName || "N/A"}
          />
          <InfoRow
            label="Calibration Start Time"
            value={datasheetDetails?.calibrationStartTime
              ? moment(datasheetDetails?.calibrationStartTime).format("DD-MM-YYYY hh:mm A")
              : "N/A"}
          />
          <InfoRow
            label="Calibration End Time"
            value={datasheetDetails?.calibrationEndTime
              ? moment(datasheetDetails?.calibrationEndTime).format("DD-MM-YYYY hh:mm A")
              : "N/A"}
          />
        </Grid>
      </Box>
    </Modal>
  );
};

export default CalibrationStartEndTimeModal;